export interface PraiseListenerInterface {
  praiseAdded(status: string);
}

export class PraiseService {
  praiseListeners: Array<PraiseListenerInterface> =
    new Array<PraiseListenerInterface>();

  standardPraises: Array<string> = [
    "Awesome!",
    "Great!",
    "Almost there!",
    "Keep going!",
    "Well done!",
    "Great job!",
    "You can do it!",
  ];

  accomplishmentPraises: Array<string> = ["You rock!", "You're the best!"];

  public praise(standard: boolean) {
    let praises = standard ? this.standardPraises : this.accomplishmentPraises;
    let praise = praises[Math.floor(Math.random() * praises.length)];

    this.praiseListeners.forEach((listener: PraiseListenerInterface) => {
      listener.praiseAdded(praise);
    });
  }

  public addPraiseListener(listener: PraiseListenerInterface) {
    this.praiseListeners.push(listener);
  }

  public removePraiseListener(listener: PraiseListenerInterface) {
    this.praiseListeners.splice(this.praiseListeners.indexOf(listener), 1);
  }
}
